import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { 
      hasError: false 
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { 
      hasError: true,
      error 
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // 可以在这里记录错误日志
    console.error('Uncaught error:', error, errorInfo);
  }

  handleResetError = () => {
    this.setState({ 
      hasError: false,
      error: undefined,
      errorInfo: undefined 
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-container">
            <h1>😱 出错了！</h1>
            <p>非常抱歉，应用程序遇到了一些问题。</p>
            
            {this.state.error && (
              <div className="error-details">
                <h3>错误信息：</h3>
                <pre>{this.state.error.message}</pre>
              </div>
            )}

            <div className="error-actions">
              <button 
                onClick={this.handleResetError} 
                className="btn btn-secondary"
              >
                重新加载页面
              </button>
              
              <Link 
                to="/" 
                className="btn btn-primary"
              >
                返回首页
              </Link>
            </div>

            <div className="error-tips">
              <h3>建议：</h3>
              <ul>
                <li>刷新页面</li>
                <li>检查网络连接</li>
                <li>稍后重试</li>
                <li>如果问题持续，请联系技术支持</li>
              </ul>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

